import { Outlet } from "react-router-dom";

import { AppFooter } from "@/core/components/layout/app-footer";
import { AppHeader } from "@/core/components/layout/app-header";
import { AppSidebar } from "@/core/components/layout/app-sidebar";
import { ScrollToTop } from "@/core/components/layout/scroll-to-top";
import {
  SidebarInset,
  SidebarProvider,
} from "@/core/components/ui/sidebar";
import { useUiStore } from "@/core/stores/ui.store";
import { PageTransitionWrapper } from "@/core/utils/transitions/pageTransition";

/**
 * Layout applicatif (zone authentifiée `/app`) : sidebar + header sticky +
 * contenu (Outlet, avec transition de page) + footer, fond tokenisé.
 * L'état d'ouverture de la sidebar est persisté dans `useUiStore`
 * (même store que la langue et le thème).
 */
export function AppLayout() {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const setSidebarOpen = useUiStore((s) => s.setSidebarOpen);

  return (
    <SidebarProvider open={sidebarOpen} onOpenChange={setSidebarOpen}>
      <AppSidebar />
      <SidebarInset className="bg-background">
        <AppHeader />
        <div className="min-w-0 flex-1 px-3 py-4 sm:px-6">
          <PageTransitionWrapper>
            <Outlet />
          </PageTransitionWrapper>
        </div>
        <AppFooter />
      </SidebarInset>
      <ScrollToTop />
    </SidebarProvider>
  );
}
